class CmLookCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.cm-look-carousel__track');
    if (!this.track) return;
    this.querySelector('.cm-look-carousel__nav--prev')?.addEventListener('click', () => this.go(-1));
    this.querySelector('.cm-look-carousel__nav--next')?.addEventListener('click', () => this.go(1));
  }
  go(dir) {
    const w = this.track.clientWidth;
    const count = this.track.children.length;
    const index = Math.round(this.track.scrollLeft / w);
    const next = (index + dir + count) % count;
    this.track.scrollTo({ left: next * w, behavior: 'smooth' });
  }
}
if (!customElements.get('cm-look-carousel')) customElements.define('cm-look-carousel', CmLookCarousel);
